import { Link, useNavigate } from 'react-router-dom';
import { useSession, useSignOut } from '@/lib/queries';
import { Button } from '@/components/ui/button';
import { LogOut, Mail, Settings } from 'lucide-react';

export function Header() {
  const { data: session } = useSession();
  const signOut = useSignOut();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 border-b-2 border-(--color-brand-terracotta) bg-(--color-brand-gold)">
      <div className="container-wide flex h-14 items-center justify-between gap-4">
        <Link to="/" className="font-serif text-lg font-semibold tracking-tight text-(--color-foreground)">
          Ceccarius
        </Link>
        <nav className="flex items-center gap-2">
          {session ? (
            <>
              {session.user.role === 'admin' && (
                <Button asChild variant="ghost" size="sm" className="text-(--color-foreground) hover:bg-black/5">
                  <Link to="/admin">
                    <Settings className="h-4 w-4" />
                    <span className="hidden sm:inline">Admin</span>
                  </Link>
                </Button>
              )}
              <span className="hidden text-sm text-(--color-foreground)/70 sm:inline">
                {session.user.name}
              </span>
              <Button
                asChild
                variant="ghost"
                size="sm"
                className="text-(--color-foreground) hover:bg-black/5"
              >
                <a
                  href="https://webmail.aruba.it/new/auth/login"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Apri la webmail"
                >
                  <Mail className="h-4 w-4" />
                </a>
              </Button>
              <Button
                variant="ghost"
                size="sm"
                className="text-(--color-foreground) hover:bg-black/5"
                onClick={async () => {
                  await signOut.mutateAsync();
                  navigate('/login');
                }}
              >
                <LogOut className="h-4 w-4" />
                <span className="hidden sm:inline">Esci</span>
              </Button>
            </>
          ) : null}
        </nav>
      </div>
    </header>
  );
}
